// extracted by mini-css-extract-plugin
export default {"rating":"RS-z","numberOfStars":"SS-z","count":"TS-z","barGraphSpacing":"US-z","barGraph":"VS-z"};